'use client'

import { Popover as PopoverPrimitive } from '@base-ui/react/popover'
import { cn } from '@/lib/utils'

/*
 * GoodUnited / Popover. Figma: 10 / Components / Popover (Popover/Filters).
 * Colors/surface/overlay, 12px corners, 16px padding and gap, default border.
 */
const Popover = PopoverPrimitive.Root

function PopoverTrigger({ className, ...props }: Omit<PopoverPrimitive.Trigger.Props, 'className'> & { className?: string }) {
    return (
        <PopoverPrimitive.Trigger
            data-slot='popover-trigger'
            className={className}
            {...props}
        />
    )
}

type PopoverContentProps = Omit<PopoverPrimitive.Popup.Props, 'className'> & {
    className?: string
    side?: PopoverPrimitive.Positioner.Props['side']
    align?: PopoverPrimitive.Positioner.Props['align']
    sideOffset?: number
}

function PopoverContent({ className, side = 'bottom', align = 'start', sideOffset = 4, ...props }: PopoverContentProps) {
    return (
        <PopoverPrimitive.Portal>
            <PopoverPrimitive.Positioner side={side} align={align} sideOffset={sideOffset} className='z-50'>
                <PopoverPrimitive.Popup
                    data-slot='popover-content'
                    className={cn(
                        'flex w-80 origin-(--transform-origin) flex-col gap-4 rounded-xl border border-border-default bg-surface-overlay p-4 text-text-primary shadow-popover outline-none data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95',
                        className
                    )}
                    {...props}
                />
            </PopoverPrimitive.Positioner>
        </PopoverPrimitive.Portal>
    )
}

function PopoverTitle({ className, ...props }: Omit<PopoverPrimitive.Title.Props, 'className'> & { className?: string }) {
    return (
        <PopoverPrimitive.Title
            data-slot='popover-title'
            className={cn('text-sm font-medium text-text-primary', className)}
            {...props}
        />
    )
}

function PopoverDescription({ className, ...props }: Omit<PopoverPrimitive.Description.Props, 'className'> & { className?: string }) {
    return (
        <PopoverPrimitive.Description
            data-slot='popover-description'
            className={cn('text-sm text-text-secondary', className)}
            {...props}
        />
    )
}

export { Popover, PopoverContent, PopoverDescription, PopoverTitle, PopoverTrigger }
